import { useState } from "react";
import Api from "lib/api/httpRequestHelper";
import { Container } from "@material-ui/core";
import FilterCard from "components/_refactor/filter-card";
import HeaderClientes from "components/_refactor/headers/clients";
import MonthYearField from "components/_refactor/fields/month-year";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import TableGestaoCobranca from "./components/table";
import DialogDetails from "./components/dialog-details";
import getMonthByNumber from "utils/get-month-by-number";

const MONTH_INDEX = new Date().getMonth() + 1;
const YEAR = new Date().getFullYear();

export default function GestaoCobranca({ view = "admin" }) {
  const isClient = view === "client";
  const [month, setMonth] = useState({
    value: MONTH_INDEX,
    label: getMonthByNumber(MONTH_INDEX),
  });
  const [year, setYear] = useState({ value: YEAR, label: String(YEAR) });
  const [searching, setSearching] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(25);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [idLoja, setIdLoja] = useState("");

  const snackbar = useSnackbar();

  const handleSearch = async () => {
    setSearching(true);
    const dataInicio = `${year.value}-${month.value
      .toString()
      .padStart(2, "0")}-01`;
    const dataFim = `${year.value}-${month.value
      .toString()
      .padStart(2, "0")}-${new Date(year.value, month.value, 0).getDate()}`;
    try {
      const response = await Api.get(
        "list-billing-charges",
        "franquias",
        `?page=${page}&pageSize=${sizePerPage}` +
          (month && year ? `&dataInicio=${dataInicio}&dataFim=${dataFim}` : ""),
        true
      );
      setData(
        response.Result.Lojas.map((loja) => ({
          ...loja,
          Base: loja.TotalBase,
          Valor: loja.Cobrancas.reduce(
            (sum, cobranca) => sum + (Number(cobranca.ValorCobrado) || 0),
            0
          ),
          Status: loja.Cobrancas?.every(
            (cobranca) => cobranca.Status === "APROVADO"
          )
            ? "Aprovado"
            : "Pendente",
        }))
      );
      setTotalRegistros(response.Result.TotalItems || 0);
      setPage(response.Result.Pagina || 0);
      setSizePerPage(response.Result.PageSize || 25);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar as regras: " + error.message, {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const handleClearFilters = () => {
    setMonth("");
    setYear("");
  };

  return (
    <>
      <HeaderClientes
        section={isClient ? "Extrato de Serviços" : "Gestão de Cobrança"}
        subsection={isClient ? "Financeiro" : "Administração de Franquias"}
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          searching={searching}
          disabled={!month || !year}
          handleClearFilters={handleClearFilters}
        >
          <MonthYearField
            month={month}
            handleMonthChange={setMonth}
            year={year}
            handleYearChange={setYear}
            disabled={searching}
            required={true}
            lg={6}
          />
        </FilterCard>
        <TableGestaoCobranca
          data={data}
          totalRegistros={totalRegistros}
          page={page}
          onAction={(row) => {
            setIdLoja(row.IdPessoaLoja);
            setOpenDialog(true);
          }}
          sizePerPage={sizePerPage}
          onTableChange={(_, { page, sizePerPage }) => {
            handleSearch({ page: page - 1, sizePerPage });
          }}
          isClient={isClient}
          dateReference={`${year.value}-${month.value
            .toString()
            .padStart(2, "0")}-01`}
        />
      </Container>

      {openDialog && (
        <DialogDetails
          onClose={() => {
            setOpenDialog(false);
            setIdLoja("");
          }}
          idLoja={idLoja}
          mes={month}
          ano={year}
        />
      )}
    </>
  );
}
